export enum LanguageCode {
  Unknown = '',
  English = 'en',
  French = 'fr',
  Deutsch = 'de',
  Nederlandse = 'nl',
  Spanish = 'es'
}


// WEBPACK FOOTER //
// ./src/types/tenants/language-code.ts